import React from "react";

import './_system_status.scss'
import {Breadcrumb, BreadcrumbItem, Column, Grid, Tile} from "@carbon/react";
import {Link} from "react-router-dom";
import DiscardedMailsTable from "../../components/DiscardedMailsTable";

const SystemStatus = () => {
  return (
    <Grid fullWidth className="alarms-page">
      <Column lg={16} md={8} sm={4} >
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Sistema
              </BreadcrumbItem>
              <BreadcrumbItem>
                Stato Sistema
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Stato Sistema
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="status-page__r1">
            <Tile>
              <DiscardedMailsTable />
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default SystemStatus